import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { imageFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteAcademyFragment = contentfulGql`#graphql
  ${imageFragment}
  fragment EntWebsiteAcademy on Academy {
    academyTitle
    description
    starRating
    reviewCount
    image {
      ...Image
    }
    academyUrl
  }
`;

export const entWebsiteAcademyModuleFragment = contentfulGql`#graphql
  ${entWebsiteAcademyFragment}
  fragment EntWebsiteAcademyModule on EntWebsiteAcademyModule {
      slug
      title
      descriptionText
      browseTitle 
      academiesCollection(limit: 10) {
        items {
          ...EntWebsiteAcademy
        }
      }
    }
`;

export const entWebsiteBlockAcademyQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteAcademyModuleFragment}

  query entWebsiteBlockAcademy($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteAcademyModule
      }
    }
  }
`;
